import React, { useState, useEffect } from 'react';
import { getRol, getUserName } from '../../../_utils/storage_handler';
import { Tabs, Tab } from '@mui/material';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Modal from '@mui/material/Modal';
import {
  findOrdersEvent
} from '../../../_events/orders/find_order.event';
import { deleteOrdersEvent, displayPDFOrderEvent, deleteOrderDetailEvent, aproverOrdersEvent } from '../../../_events/orders/order_box.event';
import { message } from 'antd';
import PrimaryProgress from '../../../containers/progress/primary_progress';
import RolledUpBoxList from './rolledUp_list';
import Chip from '@mui/material/Chip';
import {
  pdfReelEvent,
  generatePdfBoxEvent,
  reprogramEvent
} from '../../../_events/orderDetail/orderDetail.event';

import {
  buildStickerBox,
  validateStickerBox
} from '../../../_events/orderDetail/orderDetail.input';
import {
  validatePrintBody
} from '../../../_events/orders/order_box.input';
import { isNotViewer } from '../../../_utils/render_actions';
import { downloadPDFFile } from '../../../_utils/download_file.util';
import { printStickersEvent, printStickersRolEliotEvent, printStickersRolEvent, printStickersRolNalsaniEvent, printStickersRolReymonEvent } from '../../../_events/print/create.event';
import { buildPrintModel, buildPrintOrderEanModel, buildPrintOrderEanReymonModel, buildPrintRolModel } from '../../../_events/print/model';
import BarcodeInput from './barcode_input';
import { findEanByClientColorProduct } from '../../../_services/ean.service';
import Filters from './filters';
import { findAllPrinterEvent } from '../../../_events/print/find.event';
import PrinterConfig from './printer_config';
import BasicPopconfirm from '../../../containers/popconfirms/basic_popconfirm';
import ModalPendingPdf from './modals/modalPendingPdf';
import ModalPending from './modals/modalPending';
import ModalCreateAlert from '../weaving/modals/modal-create-alert';
import { specialEanClientsObj } from '../../../_config/special-ean-clients';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 4,
};

const stylePDF = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #fff',
  borderRadius: '20px',
  boxShadow: 24,
  p: 4,
};

const RolledUpBox = () => {

  const in_process='ENRO'

  const [order, setOrder] = useState([]);
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(false);
  const [orderDetail, setOrderDetail] = useState(false);
  const [open, setOpen] = React.useState(false);
  const [openPDF, setOpenPDF] = React.useState(false);
  const [openPDFReel, setOpenPDFReel] = React.useState(false);

  const [pdf, setPDF] = React.useState(null);
  const [process_state, setProcess_state] = useState([]);
  const [tabValue, setTabValue] = useState(0);
  const [openModal, setOpenModal] = React.useState(false);
  const [openModalBox, setOpenModalBox] = React.useState(false);
  const [openModalCajas, setOpenModalCajas] = React.useState(false);
  const [cut, setCut] = React.useState(0);//esto siempre hace referencia al la conversion de kilos de lo que se totalImp que hace referencia a la cantidad de metros impresa

  const [crudoCheck, setCrudoChecked] = React.useState(false);
  const [keepCheck, setKeepChecked] = React.useState(false);
  const [conversion_cut, setConversionCut] = useState();
  const [totalImp, setTotalImp] = useState();
  const [customer_formulas, setCustomer_formulas] = useState([]);
  const [modalDataBox, setModalDataBox] = React.useState(false);

  //variables of filter
  const [dateStartFilter, setDateStartFilter] = useState(false);
  const [idOrderFilter, setIdOrderFilter] = useState(false);
  const [clientFilter, setClientFilter] = useState(false);
  const [colorFilter, setColorFilter] = useState(false);
  const [ordersFilter, setOrdersFilter] = useState(false);
  const [refFilter, setRefFilter] = useState(false);

  const [printer, setPrinter] = useState(null);
  const [printers, setPrinters] = useState([]);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const stickerBoxGenerate = (newKiloBox) => {
    try{
      let kiloCut = null;
      if(newKiloBox){
        kiloCut = orderDetail.quantity > newKiloBox ? newKiloBox : null;
      }
      if(orderDetail.type_quantity === 'KG' && !newKiloBox) throw new Error('Pedido en KILOS y no hay KILOS especificados. Debe PERSONALIZAR el sticker de la caja');
      const body = {
        order_uuid: order.uuid,
        orderDetail,
        newKiloBox,
        mts_print: totalImp,
        pending: orderDetail.type_quantity === 'KG' ? kiloCut : cut > 0 ? cut : null,
        type_pending: orderDetail.type_quantity === 'KG' ? 'KG' : cut > 0 ? orderDetail.type_quantity : null,
        process_pending: keepCheck || kiloCut ? 'ENRO' : crudoCheck ? 'CRUD' : null

      }
      const ip = printer?.ip;
      const printer_id = printer?.id;
      printStickersEvent(buildPrintModel(ip, printer_id, body.orderDetail.id_detail, body.orderDetail.productPrice?.client?.name, body.orderDetail.productPrice?.product?.ref, body.orderDetail.color?.cod, body.mts_print, body.newKiloBox ? body.newKiloBox : 'N.A.', ''))
      .then(json => {
        message.success('Sticker caja generado');
        if (orderDetail?.productPrice?.client?.cod === 'NAL0001') {
          findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid)
            .then(ean => {
              if (!ean.data.serial) message.error('EAN no está configurado');
              printStickersRolNalsaniEvent(
                buildPrintOrderEanModel(ip, printer_id, orderDetail?.productPrice?.product?.ref, orderDetail?.color?.cod, printBoxBody.mt_reel, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.productPrice?.product?.description, ean.data.serial, order.oc)
              )
                .then(json => {
                  message.success('Sticker Nalsani generado');
                  generatePdfBoxEvent(body)
                    .then(data => {
                      handleClose();
                      setKeepChecked(false);
                      setCrudoChecked(false);
                      setModalDataBox(false);
                      setOpenModalBox(false);
                      setCut(0);
                      loadOrders();
                      //setPDF(data.data);
                      downloadPDFFile(data.data, 'Etiqueta de caja');
                    })
                    .catch(err => {
                      message.error(err.message);
                    });
                })
                .catch(err => {
                  message.error('Sticker caja Nalsani error');
                  message.error(err.message);
                });
            })
            .catch(err => {
              message.error(err.message);
            });
        } else if (orderDetail?.productPrice?.client?.cod === specialEanClientsObj.reymon) {
          findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid)
            .then(ean => {
              if (!ean.data.serial) message.error('EAN no está configurado');
              if(!ean.data.clientproduct && !ean.data.clientcolor) throw new Error('EAN de cliente no ha sido configurado');
              printStickersRolReymonEvent(
                buildPrintOrderEanReymonModel(ip, printer_id, ean.data.clientproduct, ean.data.clientcolor, body.mts_print, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.color?.description, ean.data.serial, order.oc)
              )
                .then(json => {
                  message.success('Sticker Reymon generado');
                  generatePdfBoxEvent(body)
                    .then(data => {
                      handleClose();
                      setKeepChecked(false);
                      setCrudoChecked(false);
                      setModalDataBox(false);
                      setOpenModalBox(false);
                      setCut(0);
                      loadOrders();
                      //setPDF(data.data);
                      downloadPDFFile(data.data, 'Etiqueta de caja');
                    })
                    .catch(err => {
                      message.error(err.message);
                    });
                })
                .catch(err => {
                  message.error('Sticker caja Nalsani error');
                  message.error(err.message);
                });
            })
            .catch(err => {
              message.error(err.message);
            });
        } else {
          generatePdfBoxEvent(body)
            .then(data => {
              handleClose();
              setKeepChecked(false);
              setCrudoChecked(false);
              setModalDataBox(false);
              setOpenModalBox(false);
              setCut(0);
              loadOrders();
              //setPDF(data.data);
              downloadPDFFile(data.data, 'Etiqueta de caja');
            })
            .catch(err => {
              message.error(err.message);
            });
        }
      })
      .catch(err => {
        message.error('Sticker caja error');
        message.error(err.message);
      });
    } catch(err) {
      message.error(err.message);
    }
  };

  const [printBoxBody, setPrintBoxBody] = useState({
    number_reels_mt: '',
    mt_reel: '',
    short: '',
    number_reels_kg: '',
    total_kg: '',
    manager: '',
  });

  const handleOpen = () => {
    setOpen(true);
    setPrintBoxBody({
      number_reels_mt: '',
      mt_reel: '',
      short: '',
      number_reels_kg: '',
      total_kg: '',
      manager: '',
    });
  };

  const handleClose = () => {
    setOpen(false);
    setOpenModal(false);
    setOpenModalCajas(false);
  };


  const handleClosePDF = () => {
    setOpenPDF(false);
  };

  const loadOrders = () => {
    setLoading(true);
    findOrdersEvent('ENRO')
      .then(data => {
        let orders_list = [];
        let process_list = [];
        let customer_formulas = [];
        data.list.forEach(obj => {
          if (obj.uuid != null && obj.id) {
            orders_list.push(obj);
          } else if (obj.name != null && obj.cod != null && obj.cod != 'CRUD' && obj.cod != 'ENRO' && obj.cod != 'ALIS' && obj.cod != 'TINT' && obj.cod != 'MARC') {
            process_list.push(obj);
          } else if (obj.id != null && obj.machine != null) {
            customer_formulas.push(obj);
          }
        });
        console.log(process_list)
        setOrders(orders_list);
        setOrdersFilter(false);
        process_list.sort((a, b) => (a.cod === 'DEFE') ? -1 : ((b.cod === 'DEFE') ? 1 : 0));
        setProcess_state(process_list);
        setLoading(false);
      })
      .catch(err => {
        message.error(err.message);
        setLoading(false);
      });
  }

  const setEditOrder = (o, p) => {
    setOrder({ uuid: p.uuid, order: o, oc: p.purchase_order });
    setOrderDetail(o);
    handleOpen();
  }


  const deleteOrder = (order) => {
    deleteOrdersEvent(order.uuid)
      .then(data => {
        message.success('Orden eliminada');
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  }
  const aprove = () => {
    let selectedOptions = [];
    orders.forEach((order) => {
      let count = 0;
      order.ordersDetail.forEach((orderDetail) => {
        const selectElement = document.querySelector(`select[data-uuid="${orderDetail.uuid}"]`);
        if (selectElement) { selectedOptions.push(selectElement.value); }
        else { count = 1; }
      });
      if (count > 0) { selectedOptions.push(`all-defect-i//${order.uuid}`); count = 0; }
    });
    aproverOrdersEvent(orders, selectedOptions, in_process)
      .then(data => {
        message.success('Productos enviados');
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  };

  const handlePrint = (orderDetail, order) => {

    try {
      validatePrintBody(tabValue, printBoxBody, orderDetail);
      const totalImp = (parseInt(printBoxBody.mt_reel) * parseInt(printBoxBody.number_reels_mt)) + parseInt(printBoxBody.short);
      setTotalImp(totalImp);
      setOrderDetail(orderDetail);

      if (orderDetail.type_quantity === 'MTS') {
        if (totalImp < orderDetail.quantity) {
          const cut = orderDetail.quantity - totalImp;
          setCut(cut);
          setOpenModal(true);
        } else {
          setOpenModal(true);
          message.warning('Se esta registrando un metraje mayor o igual al pedido. Acción registrada');
        }
      }
      else {
        if (orderDetail.productPrice.product.productWeight.length === 0) {
          orderDetail.productPrice.product.productWeight.push({
            kilo: 0
          });
        }
        const cut = (totalImp * orderDetail.productPrice.product.productWeight[0].kilo) / orderDetail.productPrice.product.productWeight[0].meter
        if (cut < orderDetail.quantity) {
          setCut(cut);
          const con = (orderDetail.quantity * orderDetail.productPrice.product.productWeight[0].meter) / orderDetail.productPrice.product.productWeight[0].kilo
          setConversionCut(con);
          setOpenModal(true);
        } else {
          generatePDFReel();
        }
      }

    } catch (err) {
      message.error(err.message);
    }
  };

  const continueP = () => {
    if (crudoCheck || keepCheck) {
      generatePDFReel();
    } else {
      alert('Debe seleccionar al menos una opción (Crudo o Mantener)');
    }
  };


  const reprogram = (orderDetail) => {
    reprogramEvent(orderDetail)
      .then(data => {
        loadOrders();
        message.success('Producto reprogramado')
      })
      .catch(err => {
        message.error(err.message);
      });

  };

  const generatePDFReel = () => {
    let option = '';
    if (keepCheck) { option = 'ENRO'; }
    else if (crudoCheck) { option = 'CRUD'; }
    const infoRol = {
      rol,
      userName
    }

    const ip = printer?.ip;
    const printer_id = printer?.id;
    printStickersRoll(ip, printer_id)
      .then(json => {
        message.success('Stickers carretes generados');
        setOpenModalBox(true);
        pdfReelEvent(orderDetail, printBoxBody, infoRol)
          .then(data => {
            handleClose();
            //setPDF(data.data);
            downloadPDFFile(data.data, 'Etiqueta de carretes');
          })
          .catch(err => {
            message.error(err.message);
          });
      })
      .catch(err => {
        message.error(err.message);
        message.error('Stickers carretes error');
      });

  }

  const printStickersRoll = async (ip, printer_id) => {
    const total = printBoxBody.number_reels_mt;
    const hasShort = printBoxBody.short;
    for (let index = 1; index <= Number(total); index++) {
      if (orderDetail?.productPrice?.client?.cod === 'NAL0001') {
        let json = await findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid);
        if (!json.data?.serial) throw new Error('EAN no ha sido configurado');
        await printStickersRolNalsaniEvent(
          buildPrintOrderEanModel(ip, printer_id, orderDetail?.productPrice?.product?.ref, orderDetail?.color?.cod, printBoxBody.mt_reel, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.productPrice?.product?.description, json.data.serial, order.oc)
        );
      } else if (orderDetail?.productPrice?.client?.cod === specialEanClientsObj.reymon) {
        let json = await findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid);
        if (!json.data?.serial) throw new Error('EAN no ha sido configurado');
        if(!json.data.clientproduct && !json.data.clientcolor) throw new Error('EAN de cliente no ha sido configurado');
        await printStickersRolReymonEvent(
          buildPrintOrderEanReymonModel(ip, printer_id, json.data.clientproduct, json.data.clientcolor, printBoxBody.mt_reel, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.color?.description, json.data.serial, order.oc)
        );
      } else if (orderDetail?.productPrice?.client?.cod === 'MAN0024' || orderDetail?.productPrice?.client?.cod === 'CAC0007') {
        let json = await findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid);
        if (!json.data?.serial) throw new Error('EAN no ha sido configurado');
        let printerBody = buildPrintOrderEanModel(ip, printer_id, orderDetail?.productPrice?.product?.ref, orderDetail?.color?.cod, printBoxBody.mt_reel, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.productPrice?.product?.description, json.data.serial, order.oc);
        if(orderDetail?.productPrice?.client?.cod === 'CAC0007'){
          printerBody.color = `${printerBody.color} ${orderDetail?.color?.description}`;
          printerBody.ref = `${printerBody.ref} ${printerBody.ref_description}`;
        }
        await printStickersRolEliotEvent(printerBody);
      } else {
        await printStickersRolEvent(
          buildPrintRolModel(ip, printer_id, `Carrete ${index}/${Number(total) + Number(hasShort ? Number(hasShort) !== 0 ? 1 : 0 : 0)}`, orderDetail?.productPrice?.product?.ref, orderDetail?.color?.cod, printBoxBody.mt_reel, printBoxBody.manager)
        );
      }
    }
    if (hasShort && Number(hasShort) !== 0) {
      if (orderDetail?.productPrice?.client?.cod === 'NAL0001') {
        let json = await findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid);
        if (!json.data?.serial) throw new Error('EAN no ha sido configurado');
        await printStickersRolNalsaniEvent(
          buildPrintOrderEanModel(ip, printer_id, orderDetail?.productPrice?.product?.ref, orderDetail?.color?.cod, printBoxBody.short, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.productPrice?.product?.description, json.data.serial, order.oc)
        );
      } else if (orderDetail?.productPrice?.client?.cod === specialEanClientsObj.reymon) {
        let json = await findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid);
        if (!json.data?.serial) throw new Error('EAN no ha sido configurado');
        if(!json.data.clientproduct && !json.data.clientcolor) throw new Error('EAN de cliente no ha sido configurado');
        await printStickersRolReymonEvent(
          buildPrintOrderEanReymonModel(ip, printer_id, json.data.clientproduct, json.data.clientcolor, printBoxBody.short, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.color?.description, json.data.serial, order.oc)
        );
      } else if (orderDetail?.productPrice?.client?.cod === 'MAN0024' || orderDetail?.productPrice?.client?.cod === 'CAC0007') {
        let json = await findEanByClientColorProduct(orderDetail?.productPrice?.client?.uuid, orderDetail?.color?.uuid, orderDetail?.productPrice?.product?.uuid);
        if (!json.data?.serial) throw new Error('EAN no ha sido configurado');
        let printerBody = buildPrintOrderEanModel(ip, printer_id, orderDetail?.productPrice?.product?.ref, orderDetail?.color?.cod, printBoxBody.short, printBoxBody.manager, orderDetail?.id_detail, orderDetail?.productPrice?.client?.name, orderDetail?.productPrice?.client?.cod, orderDetail?.productPrice?.product?.description, json.data.serial, order.oc);
        if(orderDetail?.productPrice?.client?.cod === 'CAC0007'){
          printerBody.color = `${printerBody.color} ${orderDetail?.color?.description}`;
          printerBody.ref = `${printerBody.ref} ${printerBody.ref_description}`;
        }
        await printStickersRolEliotEvent(printerBody);
      } else {
        await printStickersRolEvent(buildPrintRolModel(ip, printer_id, `Carrete ${Number(total) + 1}/${Number(total) + 1}`, orderDetail?.productPrice?.product?.ref, orderDetail?.color?.cod, printBoxBody.short, printBoxBody.manager));
      }
    }
  }

  const displayPDF = (order) => {
    if (!order) message.error('No hay orden');
    else {
      let o = Object.assign({}, order);
      displayPDFOrderEvent(o)
        .then(data => {
          setPDF(data.data.toAproveJSON);
          setOpenPDF(true);
        })
        .catch(err => {
          message.error(err.message);
        });
    }
  }

  const deleteOrderDetail = (detail) => {
    deleteOrderDetailEvent(detail.uuid)
      .then(data => {
        message.success('Producto eliminado');
        loadOrders();
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  //methods of filter
  const filterOrders = () => {
    let filteredOrders = orders;
    if (colorFilter) {
      filteredOrders = colorFilter ? filteredOrders.map(order => ({
        ...order,
        ordersDetail: order?.ordersDetail?.filter(od => od?.color?.cod?.toLowerCase().includes(colorFilter?.toLowerCase()))
      })) : filteredOrders;
    }
    if (clientFilter) {
      filteredOrders = clientFilter ? filteredOrders.map(order => ({
        ...order,
        ordersDetail: order?.ordersDetail?.filter(od => od?.productPrice?.client.name?.toLowerCase().includes(clientFilter?.toLowerCase()))
      })) : filteredOrders;
    }

    if (refFilter) {
      filteredOrders = refFilter ? filteredOrders.map(order => ({
        ...order,
        ordersDetail: order?.ordersDetail?.filter(od => od?.productPrice?.product.ref?.toLowerCase().includes(refFilter?.toLowerCase()))
      })) : filteredOrders;
    }

    if (idOrderFilter) {
      filteredOrders = filteredOrders.filter(order =>
        order.id.toString().toLowerCase().includes(idOrderFilter.toLowerCase())
      );
    }

    filteredOrders = filteredOrders.filter(order => order?.ordersDetail?.length > 0);

    setOrdersFilter(filteredOrders);
  };


  const cleanFilterOrders = () => {
    setDateStartFilter(false);
    setIdOrderFilter(false);
    setClientFilter(false);
    setColorFilter(false);
    setOrdersFilter(false);
    setRefFilter(false);

  }

  const loadPrinters = () => {
    findAllPrinterEvent()
      .then(json => {
        setPrinters(json.list);
        if (json.list.length > 0) setPrinter(json.list[0]);
      })
      .catch(err => {
        message.error(err.message);
      });
  }

  useEffect(() => {
    loadOrders();
    loadPrinters();
  }, []);

  let rol = getRol();
  let userName = getUserName();


  return (
    <Grid container spacing={1} >
      <Grid item xs={12} md={12}>
        <Typography variant="h6" component="h6">
          Bandeja de Enrollado
        </Typography>
        <hr />
        {
          loading ? (
            <PrimaryProgress />
          ) : (
            <Grid container spacing={1}>
              <Grid item xs={12} md={12}>
                <PrinterConfig
                  printers={printers}
                  loadPrinters={loadPrinters}
                />
                <Filters
                  setDateStartFilter={(dateStart) => setDateStartFilter(dateStart)}
                  setIdOrderFilter={(idOrder) => setIdOrderFilter(idOrder)}
                  setClientFilter={(client) => setClientFilter(client)}
                  setColorFilter={(color) => setColorFilter(color)}
                  setRefFilter={(ref) => setRefFilter(ref)}
                  filterOrders={filterOrders}
                  cleanFilterOrders={cleanFilterOrders}
                />
              </Grid>

              <Grid item xs={12} md={12}>
                <BarcodeInput
                  setEditOrder={setEditOrder}
                />
              </Grid>

              <Grid item xs={6} md={6}>
                <div style={{ display: 'flex', flexDirection: 'row', width: '100%' }}>
                  <Chip label={`Total: ${ordersFilter ? ordersFilter.length : orders.length}`} color="primary" variant="outlined" />
                  <Chip label={`Entregas INMEDIATAS: ${ordersFilter ? ordersFilter.filter(o => o.date_delivery === null).length : orders.filter(o => o.date_delivery === null).length}`} color="error" variant="outlined" />
                  <Chip label={`Seleccionadas: ${orders.filter(o => o.checked === 1).length}`} color="success" variant="outlined" />
                </div>
              </Grid>
              <div style={{ display: 'flex', flexDirection: 'row-reverse', width: '100%' }}>
                <div style={{ marginLeft: '20px' }}>
                <BasicPopconfirm
                  label='Aprobar órdenes'
                  title='¿Seguro/a que deseas aprobar todas las órdenes seleccionadas?'
                  onConfirm={() => { isNotViewer(rol) ? aprove() : alert('Usuario informativo') }}
                />
                </div>

                <div style={{ marginLeft: '20px' }}>
                  <ModalPendingPdf />
                </div>

                <div style={{ marginLeft: '20px' }}>
                  <ModalPending />
                </div>

                <div style={{ marginLeft: '20px' }}>
                  <ModalCreateAlert />
                </div>

              </div>
              <Grid item xs={12} md={12}>
                <RolledUpBoxList
                  data={ordersFilter ? ordersFilter : orders}
                  process={process_state}
                  setEditOrder={(o, p) => setEditOrder(o, p)}
                  reprogram={(od) => reprogram(od)}
                  deleteOrderDetail={(detail) => deleteOrderDetail(detail)}
                  updateDataOrdersChecked={(d) => {
                    let index = orders.findIndex(o => o.uuid === d.uuid);
                    if (index === -1) {
                      message.error('No se logró seleccionar');
                    } else {
                      let orders_updated = [...orders];
                      orders_updated[index].checked = orders_updated[index].checked === 0 ? 1 : 0;
                      setOrders(orders_updated);
                    }
                  }}
                  deleteOrder={(o) => { isNotViewer(rol) ? deleteOrder(o) : alert('Usuario informativo') }}
                  displayPDF={(o) => displayPDF(o)}
                />
              </Grid>
            </Grid>
          )
        }
      </Grid>
      <Modal
        open={openPDF}
        onClose={handleClosePDF}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={stylePDF}>
          <Grid container spacing={1}>
            {
              !pdf ? <>Cargando...</> :
                <Grid item xs={12} md={12}>
                  <object width="100%" height="600px"
                    data={`data:application/pdf;base64,${pdf}`}
                    type="application/pdf" className="internal"
                  >
                    <embed
                      src={`data:application/pdf;base64,${pdf}`}
                      type="application/pdf"
                    />
                  </object>
                </Grid>
            }
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={openPDFReel}
        onClose={() => {
          setOpenPDFReel(false);
          setOpenModalBox(true);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={stylePDF}>
          <Grid container spacing={1}>
            {
              !pdf ? <>Cargando...</> :
                <Grid item xs={12} md={12}>
                  <object width="100%" height="600px"
                    data={`data:application/pdf;base64,${pdf}`}
                    type="application/pdf" className="internal"
                  >
                    <embed
                      src={`data:application/pdf;base64,${pdf}`}
                      type="application/pdf"
                    />
                  </object>
                </Grid>
            }
          </Grid>
        </Box>
      </Modal>


      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Grid container spacing={1}>
            <Grid item xs={12} md={12}>
              <Tabs
                value={tabValue}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                centered
              >
                <Tab label="informacion de etiquetado" />

              </Tabs>
              <br />
            </Grid>
            {
              order &&
              <Grid item xs={12} md={12}>
                <div style={{ fontWeight: 'bold', fontSize: '0.95em' }} >{order?.order?.productPrice?.client?.name}</div>
                <div style={{ fontWeight: 'bold', fontSize: '0.75em' }} >Ref: {order?.order?.productPrice?.product?.ref}</div>
                <div style={{ fontWeight: 'bold', fontSize: '0.75em' }} >Color: {order?.order?.color?.cod}</div>
                <div style={{ fontWeight: 'bold', fontSize: '0.75em' }} >{order?.order?.quantity} {order?.order?.type_quantity}</div>
              </Grid>
            }

            <Grid item xs={6} md={6} style={{ marginRight: 0 }}>
              {tabValue === 0 && (
                <>
                  <TextField
                    error={false}
                    style={{ width: '200%' }}
                    onChange={event => setPrintBoxBody(prevState => ({ ...prevState, number_reels_mt: event.target.value }))}
                    id="number_reels_mt"
                    label="Cantidad de carretes completos"
                    variant="outlined"
                    size="small"
                    value={printBoxBody.number_reels_mt}
                  />
                  <br /><br />
                  <TextField
                    error={false}
                    style={{ width: '200%' }}
                    onChange={event => setPrintBoxBody(prevState => ({ ...prevState, mt_reel: event.target.value }))}
                    id="mt_reel"
                    label="Metros por carrete"
                    variant="outlined"
                    size="small"
                    value={printBoxBody.mt_reel}
                  />
                  <br /><br />
                  <TextField
                    error={false}
                    style={{ width: '200%' }}
                    id="short"
                    onChange={event => setPrintBoxBody(prevState => ({ ...prevState, short: event.target.value }))}
                    label="Corta"
                    variant="outlined"
                    size="small"
                    value={printBoxBody.short}
                  />
                  <br /><br />
                  <TextField
                    error={false}
                    style={{ width: '200%' }}
                    id="manager"
                    onChange={event => setPrintBoxBody(prevState => ({ ...prevState, manager: event.target.value }))}
                    label="Encargado"
                    variant="outlined"
                    size="small"
                    value={printBoxBody.manager}
                  />
                </>
              )}
            </Grid>

            <Grid item xs={12} md={12}>
              <div>Impresora</div>
              <select value={printer?.id}
                style={{ width: '240px' }}
                onChange={(e) => {
                  setPrinter(printers.find(p => p.id === Number(e.target.value)));
                }}
              >
                {
                  printers.map((p, key) => (
                    <option value={p.id} key={`option_printer_${key}`}>
                      {p.name}
                    </option>
                  ))
                }
              </select>
            </Grid>

            <Grid item xs={12} md={12}>
              <br />
              <div style={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                  size='small'
                  variant='contained'
                  onClick={() => handlePrint(orderDetail, order)}
                >
                  Imprimir
                </Button>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Modal>

      <Modal
        open={openModal}
        onClose={() => {
          setOpenModal(false);
          setKeepChecked(false);
          setCrudoChecked(false);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">

            <div style={{ textAlign: 'center' }}>
              <p><b>! AVISO IMPORTANTE !</b></p>
            </div>

            {orderDetail.type_quantity === 'MTS' ?
              <div>
                <p>El total impreso es de:  <b>{totalImp} MTS</b> y la cantidad del producto es: <b>{orderDetail.quantity} MTS</b>,
                  su valor es menor al del producto.</p>

                <p>¿A donde desea enviar los  <b>{orderDetail.quantity - totalImp} MTS.</b> pendientes?</p>
              </div>
              :
              <div>
                <p>El total impreso es de:  <b>{totalImp} MTS</b> equivalente a <b>{cut}KG</b> y
                  la cantidad del producto es de: <b>{conversion_cut} MTS </b> equivalente a <b>{orderDetail.quantity} KG</b>
                </p>

                <p>¿A donde desea enviar los  <b>{orderDetail.quantity - cut} KG.</b> pendientes?</p>
              </div>
            }

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <label>
                <input
                  type="checkbox"
                  name="crudo"
                  checked={crudoCheck}
                  onChange={(e) => {
                    setCrudoChecked(e.target.checked);
                    setKeepChecked(false);
                  }
                  }
                /> Crudo
              </label>
              <label style={{ marginLeft: '10px' }}>
                <input
                  type="checkbox"
                  name="mantener"
                  checked={keepCheck}
                  onChange={(e) => {
                    setKeepChecked(e.target.checked)
                    setCrudoChecked(false);
                  }
                  }
                /> Mantener
              </label>
            </div>

          </Typography>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => continueP()}
            >
              Continuar
            </Button>
          </div>
        </Box>
      </Modal>


      <Modal
        open={openModalBox}
        onClose={() => {
          setOpenModalBox(false);
          setCut(0);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">

            <div style={{ textAlign: 'center' }}>
              <p><b>Confirmación</b></p>
            </div>

            <Grid style={{ margin: '14px 0' }} item xs={12} md={12}>
              <div>Impresora sticker de caja</div>
              <select value={printer?.id}
                onChange={(e) => {
                  setPrinter(printers.find(p => p.id === Number(e.target.value)));
                }}
              >
                {
                  printers.map((p, key) => (
                    <option value={p.id} key={`option_printer_${key}`}>
                      {p.name}
                    </option>
                  ))
                }
              </select>
            </Grid>

            <p>¿Desea personalizar el sticker de la caja?</p>

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <label>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => setModalDataBox(true)}
                >
                  Si
                </Button>
              </label>
              <label style={{ marginLeft: '10px' }}>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => stickerBoxGenerate()}
                >
                  No
                </Button>
              </label>
            </div>

          </Typography>
        </Box>
      </Modal>

      <Modal
        open={modalDataBox}
        onClose={() => setModalDataBox(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">

            <div style={{ textAlign: 'center' }}>
              <p>Introduzca el peso <b>(KG)</b> de la caja:</p>
            </div>
            <TextField
              label="¿Cuántos kilos pesó la caja?"
              variant="outlined"
              type="number"
              id="kilo"
              fullWidth
              required
              inputProps={{ step: 0.01 }}
            />
            <br /><br />

            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '10px' }}>
              <label>
                <Button
                  size="small"
                  variant="contained"
                  onClick={() => {

                    try {
                      let newKilos = buildStickerBox();
                      validateStickerBox(newKilos);
                      stickerBoxGenerate(newKilos);
                    } catch (err) {
                      message.error(err.message);
                    }
                  }}
                >
                  Generar etiqueta
                </Button>
              </label>
            </div>

          </Typography>
        </Box>
      </Modal>



      <Modal
        open={openModalCajas}
        onClose={() => {
          setOpenModalCajas(false);
          setCut(0);
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography variant="" component="">

            <div style={{ textAlign: 'center' }}>
              <p><b>Empacando caja </b></p>
            </div>
            <p>confirma que la cantidad de {totalImp} MTS ira en un caja?</p>
            <p>¿Desea continuar?</p>
          </Typography>
          <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
            <Button
              size="small"
              variant="contained"
              onClick={() => generatePDFReel()}
            >
              Continuar
            </Button>
          </div>
        </Box>
      </Modal>




    </Grid>

  );
}

export default RolledUpBox;
